import styled from '@emotion/styled'

export const ShiftsUIWrapper = styled.div`
  display: flex;
  height: 100%;
  align-items: center;
  flex-flow: column;
  font-family: "Roboto","Helvetica","Arial",sans-serif;
  .pageHeader{
    font-size:32px;
    color: #000000;
    margin-bottom:50px;
    margin-top:50px;
  }
  .shiftOption{
    background: #EDEDED;
    border-radius: 9px;
    min-width:300px;
    height: 64px;
    color: #000000;
    font-size:22px;
    margin-bottom:15px;
    margin-top:15px;
    text-transform:none !important;
    .shiftTime{
      font-size:14px !important;
      font-weight:normal !important;
    }
    :hover{
        background: #21C769;
        font-size:20px;
    }
  }
  `;